var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "spinner-content",
              class: _vm.isLoading ? "is-loading" : "is-hidden",
            },
            [_vm._m(0)]
          ),
          !_vm.isLoading && _vm.paymentsByInvestor.length === 0
            ? _c("div", { staticClass: "message-info has-text-centered" }, [
                _c("i", {
                  staticClass: "fas fa-exclamation-circle is-pulled-left",
                }),
                _vm._m(1),
              ])
            : _vm._e(),
          !_vm.isLoading && _vm.paymentsByInvestor.length > 0
            ? _c(
                "div",
                {
                  staticClass: "card-item select-content",
                  attrs: {
                    id: "investors-payments-card",
                    "data-cy": "investors-payments-card",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "investor-payments-card-header",
                      attrs: { "data-cy": "investor-payments-card-header" },
                    },
                    [
                      _c("h3", [_vm._v("Selecciona al inversionista")]),
                      _vm.confirmedTransactions.length > 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "is-button-secondary refresh-button",
                              attrs: {
                                id: "refresh-button",
                                disabled: !_vm.checkUserFeature(
                                  "element.consignments.button.actualizar-transacciones"
                                ),
                                rounded: "",
                                "icon-left": "fas fa-sync-alt",
                              },
                              on: { click: _vm.confirmReset },
                            },
                            [_vm._v(" Actualizar transacciones ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "investor-content" },
                    _vm._l(
                      _vm.paymentsByInvestor,
                      function ({ investor, payments }, i) {
                        return _c(
                          "div",
                          {
                            key: `investorPayments${i}`,
                            staticClass: "investor-item card-item shadowless",
                            class: `investor-${investor.name}`,
                            attrs: { "data-cy": `investor-${investor.name}` },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "investor-item-info clearfix" },
                              [
                                _c("div", { staticClass: "text-info" }, [
                                  _c("div", { staticClass: "name-content" }, [
                                    _vm._v(" " + _vm._s(investor.name) + " "),
                                  ]),
                                  _c("div", { staticClass: "fees-content" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "Nº de cuotas: " +
                                          _vm._s(payments.length)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "amount-content" }, [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "$ " +
                                          _vm._s(
                                            _vm.formatNumber(
                                              _vm.totalAmountByInvestor[i]
                                            )
                                          )
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          id: `copy-button-${investor.name}`,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            investor.isValidAmount
                                              ? _vm.copyToClipBoard(i)
                                              : null
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          investor.isValidAmount
                                            ? _c("i", {
                                                staticClass: "far fa-clone",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "far fa-clone disabledShakeButton disable button-disabled",
                                              }),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "details-content" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "javascript:void(0);",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              _vm.extendedInvestor =
                                                _vm.extendedInvestor !== i
                                                  ? i
                                                  : undefined
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.extendedInvestor === i
                                                  ? "Ocultar "
                                                  : "Ver info "
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "fa fa-chevron-down transition-slow",
                                            class: {
                                              rotate:
                                                _vm.extendedInvestor === i,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "investor-details clearfix transition-slow",
                                class: { show: _vm.extendedInvestor === i },
                              },
                              [
                                _c("div", { staticClass: "investor-column" }, [
                                  _c("table", { staticClass: "table-data" }, [
                                    _c("tr", [
                                      _c("td", [_vm._v("Razón social:")]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            investor.bankAccount.businessName
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [_vm._v("Rut:")]),
                                      _c("td", [
                                        _vm._v(_vm._s(investor.idNumber)),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v("Persona de contacto:"),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(investor.contact.name)),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [_vm._v("Email:")]),
                                      _c("td", [
                                        _vm._v(_vm._s(investor.contact.email)),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                _c("div", { staticClass: "investor-column" }, [
                                  _c("table", { staticClass: "table-data" }, [
                                    _c("tr", [
                                      _c("td", [_vm._v("Banco:")]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(investor.bankAccount.bankName)
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [_vm._v("Nº de cuenta:")]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(investor.bankAccount.number)
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [_vm._v("Tipo de cuenta:")]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(investor.bankAccount.type)
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c("td", [
                                        _vm._v("Email de confirmación:"),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            investor.bankAccount
                                              .confirmationEmail
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                                investor.isValidAmount
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "is-pulled-right button is-button-primary confirm-button",
                                        attrs: {
                                          disabled: !_vm.checkUserFeature(
                                            "element.consignments.button.confirmar"
                                          ),
                                        },
                                        on: { click: _vm.confirmConsignments },
                                      },
                                      [
                                        _c("span", { staticClass: "icon" }, [
                                          _c("i", {
                                            staticClass: "fas",
                                            class: _vm.buttonIcon,
                                          }),
                                        ]),
                                        _c("span", [_vm._v("Confirmar")]),
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        staticClass:
                                          "is-pulled-right button is-button-primary confirm-button",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c(
                                          "b-tooltip",
                                          {
                                            attrs: {
                                              multilined: "",
                                              label:
                                                "Inconsistencia en los datos de la remesa. Contactar al equipo de desarrollo.",
                                              size: "is-small",
                                              position: "is-left",
                                              type: "is-info",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Remesa Bloqueada"),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _vm.confirmedOperations
                    ? _c(
                        "p",
                        {
                          staticClass: "datails-confirmed-transactions",
                          attrs: { id: "info-confirmed-transactions" },
                        },
                        [
                          _vm._v(
                            " Hay " +
                              _vm._s(_vm.confirmedOperations) +
                              " " +
                              _vm._s(
                                _vm.confirmedOperations > 1
                                  ? "operaciones"
                                  : "operación"
                              ) +
                              " confirmada" +
                              _vm._s(_vm.confirmedOperations > 1 ? "s" : "") +
                              " que no está" +
                              _vm._s(_vm.confirmedOperations > 1 ? "n" : "") +
                              " incluida" +
                              _vm._s(_vm.confirmedOperations > 1 ? "s" : "") +
                              " en la remesa actual, "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.showConfirmedOperations =
                                    !_vm.showConfirmedOperations
                                },
                              },
                            },
                            [
                              _vm._v(
                                " revísala" +
                                  _vm._s(_vm.confirmedOperations > 1 ? "s" : "")
                              ),
                            ]
                          ),
                          _vm._v(". "),
                        ]
                      )
                    : _vm._e(),
                  _vm.showConfirmedOperations
                    ? _c(
                        "div",
                        { staticClass: "confirmed-transactions" },
                        _vm._l(
                          _vm.confirmedTransactions,
                          function (transaction) {
                            return _c(
                              "div",
                              { key: transaction._id },
                              _vm._l(
                                transaction.selectedPayments,
                                function (operation) {
                                  return _c(
                                    "div",
                                    { key: operation._id },
                                    _vm._l(
                                      operation.payments,
                                      function (quota) {
                                        return _c("div", { key: quota._id }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card-item confirmed-data",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "item-header",
                                                    },
                                                    [_vm._v("Institucional ")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "investor" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            quota.investor.name
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "item-header",
                                                    },
                                                    [_vm._v("Fecha de Pago ")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              transaction.updatedAt,
                                                              "DD/MM/YYYY HH:ss"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "item-header",
                                                    },
                                                    [_vm._v("Rut deudor ")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "id-Number",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatIdNumber(
                                                              transaction.clientIdNumber
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "item-header",
                                                    },
                                                    [_vm._v("Monto ")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "transaction-amount",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " $" +
                                                          _vm._s(
                                                            _vm.formatNumber(
                                                              quota.secondaryCurrencyConsignedAmount
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                }
                              ),
                              0
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "spinner" }, [
      _c("div", { staticClass: "double-bounce1" }),
      _c("div", { staticClass: "double-bounce2" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "message-text" }, [
      _c("span", [_vm._v("No existen nuevos pagos para remesar")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }